// ═══════════════════════════════════════════════════════════════
// API UTILITY — calls Lambda via API Gateway (Bedrock Claude Haiku)
// Set REACT_APP_API_URL in .env after Terraform deploy
// ═══════════════════════════════════════════════════════════════
const API_URL = process.env.REACT_APP_API_URL || "";

function apiHeaders(apiKey, extra = {}) {
  return { "Content-Type": "application/json", "x-api-key": apiKey, ...extra };
}

export async function askClaude(prompt, systemPrompt = "", apiKey = "") {
  if (!API_URL) throw new Error("NO_API_URL");

  const response = await fetch(`${API_URL}/chat`, {
    method: "POST",
    headers: apiHeaders(apiKey),
    body: JSON.stringify({ prompt, systemPrompt }),
  });

  if (!response.ok) {
    const err = await response.json().catch(() => ({}));
    throw new Error(err.error || `API Error ${response.status}`);
  }

  const data = await response.json();
  return data.text || "";
}

export async function fetchCosts(apiKey = "") {
  if (!API_URL) throw new Error("NO_API_URL");

  const response = await fetch(`${API_URL}/costs`, {
    method: "GET",
    headers: apiHeaders(apiKey),
  });

  if (!response.ok) {
    const err = await response.json().catch(() => ({}));
    throw new Error(err.error || `API Error ${response.status}`);
  }

  return response.json();
}
